// Guest flow FIELD: records how many guests cross each path cell and their dominant direction.
// Rendering lives in the Insight overlays (FlowLayer, systems/overlays.js); this class only maintains
// the live data + slow decay so the picture stays current.
export class FlowOverlay {
  constructor(world) {
    this.world = world;
    this.data = new Map();     // "x,z" -> { count, dx, dz }
    this._accum = 0;
  }

  // Called by the visitor system whenever an agent moves one path cell.
  record(key, dx, dz) {
    let d = this.data.get(key);
    if (!d) { d = { count: 0, dx: 0, dz: 0 }; this.data.set(key, d); }
    d.count += 1;
    d.dx += dx; d.dz += dz;
  }

  update(dt) {
    this._accum += dt;
    if (this._accum > 2) {
      this._accum = 0;
      this.data.forEach((d) => { d.count *= 0.8; d.dx *= 0.8; d.dz *= 0.8; });
    }
  }

  dispose() {
    this.data.clear();
  }
}
